import { storeInstance } from 'redux/store'
import { showAlert } from 'redux/slices/Alert'
import i18n from 'i18n'

export const handleStatus500 = (error: any, message?: string) => {
  const status = error?.status || error?.response?.status

  /**
   * Considering here all the possible 50x errors.
   * Supported codes are 500, 501, 502, 503, 504.
   */
  const hasInternalServerError = `${status}`.startsWith('50')
  const errorTitle = i18n.t('alert.error.50x')

  if (hasInternalServerError) {
    storeInstance?.dispatch(function showError(dispatch) {
      dispatch(showAlert({ title: errorTitle, message }))
    })
  }

  return error
}
